import React from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { termsHaveUpdatesSelector } from '~slices/terms';
import { useIsDesktop, useStructuredSelector } from '~hooks';
import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';
import { useHeaderStyles } from './Header.styles';
var HeaderTemp = function () {
    var _a;
    var headerClasses = useHeaderStyles();
    var isDesktop = useIsDesktop();
    var termsHaveUpdate = useStructuredSelector({
        termsHaveUpdate: termsHaveUpdatesSelector,
    }).termsHaveUpdate;
    return (React.createElement(React.Fragment, null,
        termsHaveUpdate && React.createElement("div", { className: headerClasses.overlay }),
        React.createElement("nav", { className: classNames('flex-row flex-center', headerClasses.header, (_a = {},
                _a[headerClasses.header] = termsHaveUpdate,
                _a)) }, isDesktop ? React.createElement(DesktopHeader, null) : React.createElement(MobileHeader, null))));
};
export var Header = withRouter(HeaderTemp);
